import React from 'react'
import { css } from '@emotion/react'

import color from '@/constants/color'
import { mq } from '@/components/media/media'
import logo_relic_holdings from '@/images/logo_relic_holdings.svg'
import { HeaderNav } from '@/components/section/header/header-nav'
import { headerNavList } from '@/constants/header'
import { FooterNav } from '@/components/section/footer/footer-nav'
import { FooterBottom } from '@/components/section/footer/footer-bottom'
import { footerBottomList } from '@/constants/footer'
import { navList } from '@/constants/footer'
import { BreadcrumbNav } from '@/components/common/breadcrumbNav'
import gray_bg_02 from '@/images/gray_bg_02.jpg'

type PageLayoutProps = {
  breadcrumbs: string
  breadcrumbsPath: string
  title: string
  subTitle: string
  children?: React.ReactNode
}

export const PageLayout = (props: PageLayoutProps): JSX.Element => {
  const { breadcrumbs, breadcrumbsPath, title, subTitle, children } = props

  return (
    <>
      <HeaderNav
        css={cssHeaderNav}
        url="/"
        imgSrc={logo_relic_holdings}
        alt="Relic HOLDINGS"
        navList={headerNavList}
        gradientColor={[color.blue1, color.blue2]}
        btnFontStyleCss={cssBtnFontStyle}
        arrowFillColor={color.white1}
        headerLogoCss={cssHeaderLogoSize}
      />
      <div css={cssHeadingLayout}>
        <BreadcrumbNav breadcrumbs={breadcrumbs} path={breadcrumbsPath} />
        <h1 css={cssHeadingFirst}>
          <span>{title}</span>
          <br />
          <span>{subTitle}</span>
        </h1>
      </div>
      <section css={cssContentsLayout}>{children}</section>
      <div
        css={css`
          border-top: 1px solid ${color.gray1};
        `}
      >
        <FooterNav navList={navList} />
        <FooterBottom
          copyrightLayoutCss={cssFooterBottom}
          footerBottomList={footerBottomList}
          copy="© Copyright 2021 Relic Holdings Inc. All rights reserved."
        />
      </div>
    </>
  )
}

const cssHeaderNav = css`
  padding: 9px 16px;
  box-shadow: 0 3px 6px ${color.black3};
  ${mq.pc} {
    box-shadow: 0 2px 12px ${color.black3};
  }
`

const cssHeaderLogoSize = css`
  width: 40px;
  ${mq.pc} {
    width: 65px;
  }
`

const cssBtnFontStyle = css`
  color: ${color.white1};
`

const cssHeadingLayout = css`
  padding: 84px 16px 24px;
  background-image: url(${gray_bg_02});
  background-size: cover;
  ${mq.pc} {
    padding: 152px 16px 48px;
    background-size: contain;
  }
  > ul {
    margin-bottom: 24px;
  }
`

const cssContentsLayout = css`
  padding: 48px 16px 60px;
  background-color: ${color.white1};
  ${mq.pc} {
    max-width: 1080px;
    padding: 120px 16px;
    margin: 0 auto;
  }
`

const cssHeadingFirst = css`
  color: ${color.black2};
  text-align: center;
  span {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1.6px;
    ${mq.pc} {
      font-size: 28px;
      line-height: 1.4;
      letter-spacing: 2.8px;
    }
    &:last-child {
      font-size: 28px;
      letter-spacing: 2.8px;
      ${mq.pc} {
        font-size: 48px;
        letter-spacing: 4.8px;
      }
    }
  }
`

const cssFooterBottom = css`
  padding: 24px 16px 12px;
`
